export default function PencilLineIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7 12.25H12.25M9.63672 2.63687L2.32942 9.9323L1.75 12.25L4.06771 11.6706L11.375 4.37515C11.855 3.89513 11.855 3.11688 11.375 2.63687C10.895 2.15685 10.1167 2.15685 9.63672 2.63687Z"
                stroke="#5A5F6A"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
